import React from "react";
import {confirmAlert} from "react-confirm-alert";
import PropTypes from "prop-types";

import {ARE_YOU_SHURE_TITLE, ARE_YOU_SURE_CONFIRMATION_PROCESS, NO, YES_CONTINUE} from "../i18n/i18n";

export const ConfirmAlert = ({
    path= null ,
    data,
    service,
    remove,
    title = ARE_YOU_SURE_CONFIRMATION_PROCESS,
    closeOnEscape= true,
    closeOnClickOutside= true,
})  => confirmAlert({
    closeOnEscape,
    closeOnClickOutside,
    customUI: ({onClose}) => <div className='custom-ui'>
        <h1>{ARE_YOU_SHURE_TITLE}</h1>
        <p>{title}</p>
        <button onClick={onClose}>{NO}</button>
        <button className={"btn-alert-delete"} onClick={() => {
            path != null ? remove( path, service, data ) : remove( service, data )
            onClose();
        }}>
            {YES_CONTINUE}
        </button>
    </div>
})

ConfirmAlert.propTypes = {
    data: PropTypes.object.isRequired,
    remove: PropTypes.func.isRequired,
};